import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import "react-image-gallery/styles/css/image-gallery.css"
import PanelHeader from './PanelHeader'
import ListMenu from './ListMenu'

export default function AcisPcpnMaps() {
  const [ acisMap, setAcisMap ] = useState('30 Day Pct Normal');
  const mapurl = 'https://nedews.nrcc.cornell.edu/NRCC_maps/'
  const maptitles = {
      'Current Week Total': 'dmwkptot',
      'Last 7 Days Total': 'd7ptot',
      '14 Day Pct Normal': 'd14ppct',
      '30 Day Pct Normal': 'd30ppct',
      '60 Day Pct Normal': 'd60ppct',
      '90 Day Pct Normal': 'd90ppct',
      '6 Month Pct Normal': 'mn6ppct',
      '1 Year Pct Normal': 'y1ppct',
  }
  const maplist = Object.keys(maptitles)
    
  const mapname = mapurl + maptitles[acisMap] + '_vt_current_nn.png'
  const maxWidth = window.innerWidth - 220 - 48;	//drawerWidth=220, Main padding=48

  const panelTitle = "Current ACIS Precipitation Maps"
  const addtext = " ";

  return (
    <>
      <PanelHeader
          title={panelTitle}
          addtext={addtext}
      />
      <Stack direction="column" className="mapandlegend-container">
        <div className="listmenu-container">
          <ListMenu
            selected={setAcisMap}
            list={maplist}
            title="Change Time Interval"
          />
          <Box
            component="img"
            src={mapname}
            sx={{
              maxHeight: "700px",
              maxWidth: {maxWidth},
              position: "absolute",
              left: "50%",
              transform: "translate(-50%, 0)",
              marginTop: "3em",
            }}
            alt="ACIS precipitation map"
          />
        </div>
      </Stack>
    </>
  )
}